import React from "react";
import { useTranslation } from "react-i18next";

import pubPizzaImg from "@assets/images/scan-to/ads/pub_pizza.jpg";
import pubGastronomieImg from "@assets/images/scan-to/ads/pub_gastronomie.jpg";
import pubGrilladesImg from "@assets/images/scan-to/ads/pub_grillades.jpg";

import { IMAGE_PLACEHOLDER_PATH } from "./types";
import {
    PreviewSection,
    PreviewSectionTitle,
    OffersContainer,
    AdCard,
    AdBadge,
} from "./styled";

type AdvertisingSectionProps = {
    adsEnabled: boolean;
    adsTitleVisible: boolean;
    adsConfigured: boolean;
    adsSectionTitle: string;
    adsIconPath: string;
    adsCustomIcon: string;
    adsList: Array<{ id: number; imageUrl: string }>;
    mainColor: string;
    primaryColor: string;
};

export function AdvertisingSection({
    adsEnabled,
    adsTitleVisible,
    adsConfigured,
    adsSectionTitle,
    adsIconPath,
    adsCustomIcon,
    adsList,
    mainColor,
    primaryColor,
}: AdvertisingSectionProps): JSX.Element | null {
    const { t } = useTranslation();

    if (!adsEnabled) return null;
    // Once the user has touched the Publicités tab (adsConfigured) and
    // deactivated every ad switch, hide the entire section — same UX as
    // Offres. Without this guard the empty `adsList` falls through to
    // the demo fallback (pub_pizza / pub_gastronomie / pub_grillades),
    // so flipping the last ad switch off would re-paint 3 hardcoded
    // images as if nothing was configured.
    if (adsConfigured && adsList.length === 0) return null;

    return (
        <PreviewSection>
            {adsTitleVisible && (
                <PreviewSectionTitle>
                    {adsCustomIcon ? (
                        <img
                            src={adsCustomIcon}
                            alt=""
                            style={{
                                width: 14,
                                height: 14,
                                objectFit: "contain",
                            }}
                        />
                    ) : (
                        <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill={primaryColor}
                        >
                            <path d={adsIconPath} />
                        </svg>
                    )}
                    {adsSectionTitle}
                </PreviewSectionTitle>
            )}
            <OffersContainer>
                {adsList.length > 0 ? (
                    adsList.map((ad) => (
                        <AdCard key={ad.id}>
                            {ad.imageUrl ? (
                                <img src={ad.imageUrl} alt="" />
                            ) : (
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="#ccc"
                                    style={{
                                        margin: "auto",
                                        display: "block",
                                        marginTop: "38px",
                                    }}
                                >
                                    <path
                                        d={IMAGE_PLACEHOLDER_PATH}
                                    />
                                </svg>
                            )}
                            <AdBadge mainColor={mainColor}>
                                {t("ADVERTISING")}
                            </AdBadge>
                        </AdCard>
                    ))
                ) : (
                    <>
                        <AdCard>
                            <img src={pubPizzaImg} alt="" />
                            <AdBadge mainColor={mainColor}>
                                {t("ADVERTISING")}
                            </AdBadge>
                        </AdCard>
                        <AdCard>
                            <img src={pubGastronomieImg} alt="" />
                            <AdBadge mainColor={mainColor}>
                                {t("ADVERTISING")}
                            </AdBadge>
                        </AdCard>
                        <AdCard>
                            <img src={pubGrilladesImg} alt="" />
                            <AdBadge mainColor={mainColor}>
                                {t("ADVERTISING")}
                            </AdBadge>
                        </AdCard>
                    </>
                )}
            </OffersContainer>
        </PreviewSection>
    );
}
